// extracted by mini-css-extract-plugin
module.exports = {"root":"page-wrapper_root__4j38F"};